<template>
    <div>
        <h4>Quick Replies <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-if="!isEdit" @click="isEdit = !isEdit"><span class="glyphicon glyphicon-pencil"></span> Edit</a></h4>
        <span class="small">Quick Replies คือ Choiceคำตอบที่จะแสดงด้านล่างให้ผู้ใช้กดแทนการพิมพ์ มักใช้กับคำถามที่พบบ่อย (ห้ามเกิน 20 ตัวอักษร)</span>
        <div class="row" style="margin-top: 10px;">
            <div class="col-xs-12">
                <template v-if="welcome_quickreplies">
                    <div>

                        <template v-if="isEdit">
                            <div :class="{'has-error' : errorTag.length > 0}">
                                <tags v-model="tag" :tags="replies" @tags-changed="newTags => replies = newTags" :max="10" @before-adding-tag="checkTag"></tags>
                                <!-- <vue-tags-input v-model="tag" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkTag" :max-tags="10" placeholder="Add Quick Reply"/> -->
                                <!-- <input type="hidden" v-model="tags" name="tags" data-vv-as="Keyword" v-validate="'required'"> -->
                                <!-- <textarea class="form-control mb-2" style="resize: vertical;margin-bottom:5px" rows="3" v-model="welcome_quickreplies.contentvalue" ></textarea> -->
                                <p class="text-error" v-if="errorTag.length > 0">
                                    <template v-if="errorTag.includes('overmaxlength')">
                                        Message cannot be longer than 20 characters
                                    </template>
                                    <template v-else-if="errorTag.includes('overtagmax')">
                                        Quick reply cannot be more than 10
                                    </template>	
                                    <template v-else-if="errorTag.includes('duplicate')">
                                        Duplicate quick reply
                                    </template>								
                                </p>
                            </div>
                        </template>
                        <template v-else>
                            <div class="quickreply">
                                <ul class="tags">
                                    <li class="tag" v-for="(reply,index) in replies" :key="'reply_'+index">{{reply.text}}</li>	
                                </ul>

                            </div>
                        </template>
                    </div>
                    <div class="text-center" style="margin-top: 25px;margin-bottom: 25px;">
                        <template v-if="isEdit">
                            <a href="javascript:void(0);" class="btn btn-default" @click="cancelEdit">Cancel</a>
                            <a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">Save</a>
                        </template>
                        
                    </div>
                </template>

                
            </div>

            
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'

import VueTagsInput from '@johmun/vue-tags-input';
import FacebookScreen from '@/components/elements/FacebookScreen'
import Tags from '@/components/elements/Tags'

    export default {
        props: ['value'],
        data: function(){
            return {
                isEdit: false,

                welcome_quickreplies: undefined,
                tag: '',

                errorTag: []
            }
        },
        components: {
            FacebookScreen,
            VueTagsInput,
            Tags
        },
        created: function(){
            this.welcome_quickreplies = Object.assign({}, this.value);

            this.cached_welcome_quickreplies = Object.assign({}, this.value);
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot'
            }),
            replies:{
                get () {
                    var vm = this
                    if (vm.welcome_quickreplies && vm.welcome_quickreplies.contentvalue && vm.welcome_quickreplies.contentvalue != null && vm.welcome_quickreplies.contentvalue != '') {
                        
                        var tags = vm.welcome_quickreplies.contentvalue.split(",")
                        var result = []
                        $.each(tags,function(index,val){
                            result.push({ text : val })
                        })
                        return result;
                    } else {
                        return []
                    }
                },
                set (value) {
                    let vm = this 
                    var result = []
                    $.each(value,function(index,val){
                        result.push(val.text)
                    })
                    vm.welcome_quickreplies.contentvalue = result.join(",")

                    // vm.$emit('input',Object.assign({}, this.welcome_quickreplies))
                }
            }
        },
        methods: {
            checkTag: function(obj) {
                
                // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
                // else 
                this.errorTag = []
				if(obj.tag.text.length > 20) {
                    this.errorTag.push('overmaxlength');
                    obj.error();
                }
                else if(this.replies.length >= 10) {
                    this.errorTag.push('overtagmax');
                    obj.error();
                }
                else if(obj.tag.isDuplicate ) {
                    //this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
                    this.errorTag.push('duplicate');
                    obj.error();
                }
                else obj.addTag();
            },
            cancelEdit: function(){
                var vm = this
                this.welcome_quickreplies = Object.assign({}, this.cached_welcome_quickreplies);
                
                vm.$emit('input',Object.assign({}, this.welcome_quickreplies))
                vm.isEdit = false
            },
            saveContent: function(){
                var vm = this
                vm.sendRequest(this.welcome_quickreplies)
                this.cached_welcome_quickreplies = Object.assign({}, this.welcome_quickreplies);
                
                vm.$emit('input',Object.assign({}, this.cached_welcome_quickreplies))
                vm.isEdit = false
            },
            sendRequest: function(content,callback){
                var vm = this
                api.updateConfig(content,function(error,response){
                    if (error) {
                        console.error(error)
                        return
                    }
                })
            }
        },
        watch: {
            value: function(){
                this.welcome_quickreplies = Object.assign({}, this.value);

                this.cached_welcome_quickreplies = Object.assign({}, this.value);
            }
        },
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/chatbot/QuickReply.vue